module.exports = __webpack_public_path__ + "img/hyu_gallery0.d3c88fdf.jpg";